import type User from '$shared/models/User';
import BaseStore from './BaseStore';

export type UserStoreType = {
  credUsers: User[];
};

const InitialState: UserStoreType = {
  credUsers: []
};

class UserStore extends BaseStore<UserStoreType> {
  constructor() {
    super(InitialState);
  }

  public get credUsers(): User[] {
    return this.getValue('credUsers') || [];
  }

  public setCredUsers(users: User[]): void {
    this.update('credUsers', users);
  }
}

export const userStore = new UserStore();
